import { Component, inject, OnInit } from "@angular/core";
import { BootstrapIcon, HeaderService } from "src/app/services/header.service";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { NavigationService } from "src/app/shared/data-access/navigation.service";

enum childComponents {
  ViewComponent = "productionLineViewComponent",
  DetailsPageComponent = "productionLineDetailsPageComponent",
  FormComponent = "productionLineFormComponent",
}

@Component({
  selector: "app-admin-production-line-management",
  template: `
    <h1 class="qundis-page-heading-h1">{{ getPageHeading() }}</h1>
    <router-outlet></router-outlet>
  `,
  standalone: true,
  imports: [CommonModule, RouterModule],
})
export class AdminProductionLineManagementComponent implements OnInit {
  navigationService = inject(NavigationService);
  public BootstrapIcon = BootstrapIcon;
  headerService = inject(HeaderService);

  ngOnInit(): void {
    this.headerService.setHeaderIcon(BootstrapIcon.productionLines);
    this.headerService.setHeaderTitle("Produktionslinienverwaltung");
  }

  getPageHeading() {
    switch (this.navigationService.activeComponent()) {
      case childComponents.ViewComponent:
        this.headerService.setHeaderSubTitle("Gesamtübersicht");
        return "Gelistete Produktionen";
      case childComponents.FormComponent:
        if (this.navigationService.currentUrl().includes("formAction=edit")) {
          this.headerService.setHeaderSubTitle("Produktionslinie bearbeiten");
          return "Produktionslinie bearbeiten";
        } else {
          this.headerService.setHeaderSubTitle("Neue Produktionslinie anlegen");
          return "Neue Produktionslinie anlegen";
        }
      case childComponents.DetailsPageComponent:
        this.headerService.setHeaderSubTitle("Produktionslinie bearbeiten");
        return "Produktionslinie bearbeiten";
      default:
        return "Gelistete Produktionslinien";
    }
  }
}
